import axios from "axios"
import { asyncThunkOf } from "../../../common/utils/redux-helpers"
import { SensitiveData } from "./test-hub-model"
import {
    getDecryptedInfoFailure,
    getDecryptedInfoStart,
    getDecryptedInfoSuccess,
    getEncryptedInfoStart,
    getEncryptedInfoSuccess,
    getEncryptedInfoFailure,
} from "./test-hub-slices"

export const decryptInfo = asyncThunkOf<void, string>("decryptSensitiveInfo", async (info, thunkApi) => {
    const { dispatch } = thunkApi
    dispatch(getDecryptedInfoStart())

    return axios
        .get<SensitiveData>(`/private/debug/decrypt-sensitive-data?info=${info}`)
        .then((response) => {
            dispatch(
                getDecryptedInfoSuccess({
                    data: response.data,
                })
            )
        })
        .catch((error) => {
            const errMessage = error?.message ?? "An error occurred"
            dispatch(
                getDecryptedInfoFailure({
                    error: errMessage,
                })
            )
        })
})

export const encryptInfo = asyncThunkOf<void, SensitiveData>("encryptSensitiveInfo", async (payload, thunkApi) => {
    const { dispatch } = thunkApi
    dispatch(getEncryptedInfoStart())

    return axios
        .post<string>("/private/debug/encrypt-sensitive-data", payload)
        .then((response) => {
            dispatch(
                getEncryptedInfoSuccess({
                    data: response.data,
                })
            )
        })
        .catch((error) => {
            const errMessage = error?.message ?? "An error occurred"
            dispatch(
                getEncryptedInfoFailure({
                    error: errMessage,
                })
            )
        })
})
